import React from 'react';
import HeadTittle from '../../../components/HeadTittle';
import StepperTabs from '../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../components/StepperTabs/StepTab';
import { TABS_UNREGISTERED_EXITS } from './Model/Model';
import ContractorTab from './SubComponents/ContractorTab';
import EquipmentAndMaterialTab from './SubComponents/EquipmentAndMaterialTab';
import SearchFilterBtn from '../../../components/buttons/SearchFilterBtn';
import ExportDataBtn from '../../../components/buttons/ExportDataBtn';
import MaterialDetailsModal from './Modal/MaterialDetailsModal';
import CheckInLogModal from './Modal/CheckInLogModal';
import CheckOutModal from '../Guard/IncomingContractor/Modal/CheckOutModal';
import MaterialCheckOutModal from './Modal/MaterialCheckOutModal';
import SearchFor from "../../Modals/SearchFor";
import UnregisteredExitsApp from "./Functionality/UnregisteredExitsApp";

const UnregisteredExits = () => {
    const {
        t,
        finalArray,
        setFilterDialogShow,
        steps,
        activeStep,
        setActiveStep,
        handleStepChange,
        supplierId,
        searchElement,
        setSearch,
        contractorId,
        setSimpleSearch,
        search,
        setSearchElement,
        setCriteria,
        filterDialogShow,
        setFinalArray,
        moduleId,
        option,
        criteria,
        modified,
        setModified,
        bodyForExport,
        setBodyForExport,
        searchResults,
        setSearchResults,
        detailsModal,
        setDetailsModal,
        checkOutModal,
        setCheckOutModal,
        closeModals,
        itemSelected,
        setItemSelected,
        canExport
    } = UnregisteredExitsApp();

    return (
        <>
            <HeadTittle name={t('unregistered_exits')}>
                {canExport && (
                    <ExportDataBtn
                        id='btn_ue_export_data'
                        moduleId={moduleId}
                        option={option}
                        search={search}
                        searchElement={searchElement}
                        body={search ? criteria : bodyForExport}
                        // Neither tab is exported by a contractor or a supplier, both lists belong to the
                        // employee dashboard, so the export never takes the contractor/supplier endpoints
                        contractorSupplier={false}
                    />
                )}
                <SearchFilterBtn finalArray={finalArray} fnclick={() => setFilterDialogShow(true)} />
            </HeadTittle>

            <StepperTabs
                onlyTab={true}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={TABS_UNREGISTERED_EXITS.CONTRACTORS.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_UNREGISTERED_EXITS.CONTRACTORS.INDEX && (
                        <>
                            <ContractorTab
                                supplierId={supplierId}
                                searchElement={searchElement}
                                contractorId={contractorId}
                                setSimpleSearch={setSimpleSearch}
                                finalArray={finalArray}
                                search={search}
                                setSearchElement={setSearchElement}
                                setCriteria={setCriteria}
                                setBodyForExport={setBodyForExport}
                                searchResults={searchResults}
                                setSearchResults={setSearchResults}
                                setItemSelected={setItemSelected}
                                itemSelected={itemSelected}
                                setSearch={setSearch}
                                setDetailsModal={setDetailsModal}
                                setCheckOutModal={setCheckOutModal}
                                modified={modified}
                                setModified={setModified}
                                t={t}
                            />
                        </>
                    )}
                </StepTab>
                <StepTab index={TABS_UNREGISTERED_EXITS.EQUIPMENT_AND_MATERIAL.INDEX} activeStep={activeStep}>
                    {activeStep === TABS_UNREGISTERED_EXITS.EQUIPMENT_AND_MATERIAL.INDEX && (
                        <>
                            <EquipmentAndMaterialTab
                                supplierId={supplierId}
                                searchElement={searchElement}
                                contractorId={contractorId}
                                setSimpleSearch={setSimpleSearch}
                                finalArray={finalArray}
                                search={search}
                                setSearchElement={setSearchElement}
                                setCriteria={setCriteria}
                                setBodyForExport={setBodyForExport}
                                searchResults={searchResults}
                                setSearchResults={setSearchResults}
                                setItemSelected={setItemSelected}
                                itemSelected={itemSelected}
                                setSearch={setSearch}
                                setDetailsModal={setDetailsModal}
                                setCheckOutModal={setCheckOutModal}
                                modified={modified}
                                setModified={setModified}
                                t={t}
                            />
                        </>
                    )}
                </StepTab>
            </StepperTabs>
            {(filterDialogShow || finalArray?.length > 0) && (
                <SearchFor
                    open={filterDialogShow}
                    onClose={() => {
                        setFilterDialogShow(false);
                    }}
                    onFiltered={(originalArray) => {
                        setFilterDialogShow(false);
                        setFinalArray(originalArray);
                        setSearchElement('');
                    }}
                    moduleId={moduleId}
                    option={option}
                    finalArray={finalArray}
                    cleanAdvance={modified}
                    setCleanAdvance={setModified}
                    search={search}
                    setSearch={setSearch}
                    setFinalArray={setFinalArray}
                    searchElement={searchElement}
                />
            )}
            {itemSelected && detailsModal && (
                <>
                    {activeStep === TABS_UNREGISTERED_EXITS.CONTRACTORS.INDEX ? (
                        <CheckInLogModal
                            show={detailsModal}
                            onHide={() => {
                                setDetailsModal(false);
                                setItemSelected(null);
                            }}
                            itemSelected={itemSelected}
                            setCheckOutModal={setCheckOutModal}
                            display={checkOutModal ? 'd-none' : ''}
                            t={t}
                        />
                    ) : (
                        <MaterialDetailsModal
                            show={detailsModal}
                            onHide={() => {
                                setDetailsModal(false);
                                setItemSelected(null);
                            }}
                            itemSelected={itemSelected}
                            setCheckOutModal={setCheckOutModal}
                            display={checkOutModal ? 'd-none' : ''}
                            t={t}
                        />
                    )}
                </>
            )}
            {itemSelected && checkOutModal && (
                <>
                    {activeStep === TABS_UNREGISTERED_EXITS.CONTRACTORS.INDEX ? (
                        <CheckOutModal
                            show={checkOutModal}
                            onHide={() => setCheckOutModal(false)}
                            onSuccess={() => {
                                setModified(true);
                                closeModals();
                            }}
                            itemSelected={{
                                ...itemSelected,
                                userFullName: itemSelected?.fullName,
                                equipmentAccessLogId: itemSelected?.id,
                            }}
                            // The exit registered from here is the one that was never registered at the door,
                            // so the guard picks when it happened. The guard module stamps it on confirm.
                            selectableAccessDate={true}
                        />
                    ) : (
                        <MaterialCheckOutModal
                            show={checkOutModal}
                            onHide={() => setCheckOutModal(false)}
                            onSuccess={() => {
                                setModified(true);
                                closeModals();
                            }}
                            itemSelected={itemSelected}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default UnregisteredExits;
